/* tslint:disable:no-trailing-whitespace */
import { Component } from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';
import {SeriesSelectorType} from './data/series-selector-type';
import {MessageSeriesTypeSelected} from '../../messages/message-series-type-selected';
import {MessageLastDate} from '../../messages/message-last-date';

@Component({
  selector: 'dora-series-selector',
  templateUrl: './dora-series-selector.component.html',
  styleUrls: ['./dora-series-selector.component.scss']
})
export class DoraSeriesSelectorComponent extends WidgetBaseComponent {
  @DoraProperty
  private extendedHistorical = true;

  @DoraProperty
  private extended7D = false;

  @DoraProperty
  private extended1M = true;

  @DoraProperty
  private extended2M = false;

  @DoraProperty
  private extended3M = true;

  @DoraProperty
  private extended6M = true;

  @DoraProperty
  private extended9M = false;

  @DoraProperty
  private extended1Y = true;

  @DoraProperty
  private extended2Y = false;

  @DoraProperty
  private extended3Y = true;

  @DoraProperty
  private extended5Y = true;

  @DoraProperty
  private extendedBeginY = false;

  @DoraPropertyArray(SeriesSelectorType)
  protected seriesSelectorTypes: SeriesSelectorType[] = [];

  @DoraProperty
  private defaultSeriesSelectorType = 'HISTORICAL';

  // last date evailable
  private lastDate: Date = null;

  onParameterInjectedFinished() {
    super.onParameterInjectedFinished();


    this.enableButtons();

    this.messageService.getMessage(this.EventChannel, MessageLastDate, this.CallerName).subscribe(message => {
      this.lastDate = (message.data as MessageLastDate).LastDate;

      this.enableButtons();
    });


  }
  public enableButtons() {
    // empty seriesSelectorTypes
    this.seriesSelectorTypes = [];

    // push complete
    this.seriesSelectorTypes.push(new SeriesSelectorType('HISTORICAL'));

    // now date
    const now = new Date();

    // check extended
    if (this.extendedHistorical === true) {
      if (this.extended7D) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 7 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setDay(7);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended1M) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 30 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setMonth(1);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended2M) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 60 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setMonth(2);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended3M) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 90 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setMonth(3);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended6M) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 180 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setMonth(6);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended9M) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 270 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setMonth(9);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended1Y) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 365 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setYear(1);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended2Y) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 2 * 365 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setYear(2);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended3Y) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 3 * 365 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setYear(3);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extended5Y) {
        if (this.lastDate === null || this.lastDate.getTime() > now.getTime() - 5 * 365 * 24 * 60 * 60 * 1000) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setYear(5);
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }
      if (this.extendedBeginY) {
        if (this.lastDate === null || this.lastDate.getTime() > new Date(now.getFullYear(), 0, 1).getTime()) {
          const seriesSelectorType = new SeriesSelectorType('HISTORICAL');
          seriesSelectorType.setStartOfYear();
          this.seriesSelectorTypes.push(seriesSelectorType);
        }
      }

      // set default seriesSelectorType
      this.seriesSelectorTypes.forEach((x) => {
        if (x.description === this.defaultSeriesSelectorType) {
          x.selected = true;
        }
      });
    }
  }

  public getSeriesDescription(seriesSelectorType: SeriesSelectorType): string {
    return this.translationService.get(seriesSelectorType.description);
  }

  public getSeriesTypeClass(seriesSelectorType: SeriesSelectorType): string {
    return 'SeriesSelectorType ' + seriesSelectorType.description + (seriesSelectorType.selected ? ' selected' : '');
  }

  public onSeriesSelectorTypeClick(seriesSelectorType: SeriesSelectorType): void {
    // set all seriesSelectorType to false
    this.seriesSelectorTypes.forEach((x) => {
      x.selected = false;
    });

    seriesSelectorType.selected = true;

    this.messageService.sendMessage(this.EventChannel, new MessageSeriesTypeSelected(seriesSelectorType), this.CallerName);
  }
}
